<template>
    <div>
        <DataTable :value="deals_data" selectionMode="single" dataKey="token">
            <Column header="Дата" >
                <template #body="slotProps">
                    {{short_timezoned(slotProps.data.date)}}
                </template>
            </Column>
            <Column header="Бот" field="bot_name" ></Column>
            <Column header="Направление" field="market_type_direction"></Column>
            <Column header="Действие" field="action_type"></Column>
            <Column header="Монета">
                <template #body="slotProps">
                    <div v-if="slotProps.data.pair_link">
                        <a :href="slotProps.data.pair_link" class="text-blue-500">{{slotProps.data.pair_symbol}}</a>
                    </div>
                </template>
            </Column>
            <Column header="Токен" field="token"></Column>
            <Column header="%" field="percent_profit" >
                <template #body="slotProps">
                    <div v-if="slotProps.data.percent_profit">
                        <div v-if="slotProps.data.percent_profit < 1" v-html="round_red(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                        <div v-else v-html="round_green(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                    </div>
                </template>
            </Column>
            <Column header="Профит" field="value_profit" >
                <template #body="slotProps">
                    <div v-if="slotProps.data.value_profit">
                        <div v-html="round_colored(slotProps.data.value_profit, 2)"></div>
                    </div>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import helperMethods from '@/helpers';

export default {
    components:{
        DataTable,
        Column
    },
    props:{
        deals_data: Array
    },
    methods:{
        ...helperMethods
    }
}
</script>
